import React from "react";

// import IconCheck from "@e-fork/mb/assets/icons/icon-check-24.svg?url";
// import IconError from "@e-fork/mb/assets/icons/icon-error-24.svg?url";
// import IconLoading from "@e-fork/mb/assets/icons/icon-loading-24.svg?url";
// import IconInfo from "@e-fork/mb/assets/icons/icon-info-24.svg?url";
import classNames from "classnames";
import PropTypes from "prop-types";

const StatusIcon = ({ type }) => {
  return;
  // switch (type) {
  //   case "info":
  //     return <IconInfo />;
  //   case "success":
  //     return <IconCheck />;
  //   case "loading":
  //     return <IconLoading />;
  //   case "error":
  //     return <IconError />;
  // }
};

const Status = ({ type, title, message, direction = "horizontal" }) => {
  return (
    <div
      className={classNames("status", {
        [type]: type,
        [direction]: direction,
      })}
    >
      <div className="status-indicator">
        <StatusIcon type={type} />
      </div>
      <div className="status-body">
        <span className="status-title">{title}</span>
        {message && <span className="status-message">{message}</span>}
      </div>
    </div>
  );
};

Status.propTypes = {
  type: PropTypes.oneOf(["loading", "success", "error"]).isRequired,
  title: PropTypes.string.isRequired,
  message: PropTypes.string,
  direction: PropTypes.oneOf(["horizontal", "vertical"]),
};

export default Status;
